import {HttpCrudDataSource, HttpCrudParams} from '../../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../../core/data-source/json.mapper';
import {httpService} from '../../../../core/services/http.service';
import {OrderCommunicationsRecord} from './order-communications.record';

export class OrderCommunicationsCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/orders/communications/';

    async listOrderCommunications(orderId: number): Promise<OrderCommunicationsRecord[]> {
        return httpService.get(this.apiPath + orderId, {params: new HttpCrudParams()}).then((response: any) => {
            return response.data.rows.map((list: OrderCommunicationsRecord) =>
                fromJson(OrderCommunicationsRecord, list)
            );
        });
    }
}
